module.exports = __webpack_public_path__ + "img/PF.79e6bcc2.png";